
import React from 'react';
import { CheckCircle } from 'lucide-react';

const benefits = [
  "Spara upp till 70% av anbudstiden", 
  "Få djupare förståelse för beställarens behov", 
  "Identifiera konkurrensfördelar och differentieringsmöjligheter", 
  "Minska risken för missade krav och uteslutning", 
  "Få djupare insikter för mer konkurrenskraftiga anbud", 
  "Effektivisera hela processen från analys till inlämning"
];

const Benefits = () => {
  return (
    <section id="benefits" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="p-8 md:p-10">
            <div className="text-center mb-8">
              <h3 className="text-2xl md:text-3xl font-montserrat font-bold text-darkgray mb-2">
                Fördelar med Snabbaupphandlingar
              </h3>
              <p className="text-darkgray/70 font-opensans">
                Här är varför hundratals företag redan använder vår tjänst
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors duration-200">
                  <CheckCircle className="h-5 w-5 text-yellow-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-montserrat font-medium text-darkgray">{benefit}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
              <p className="text-darkgray/70 font-opensans italic">
                "Systemet har hjälpt oss vinna 3 av de senaste 5 upphandlingarna vi deltagit i"
              </p>
              <p className="mt-2 text-sm text-darkgray/50 font-opensans">— Antti Korhonen</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
